import { fetch } from '@/modules/fetch';

// The line index.html embeds; vite.config.ts's inject-html-vars swaps the
// token at build.
const RELEASE_LINE = /window\.RELEASE = '([^']*)'/;

// 'unknown' is a build outside git, '__RELEASE__' the token never replaced:
// neither carries an identity, and comparing them would flag every tab, or
// none, forever.
export function isRealRelease(
  value: string | null | undefined,
): value is string {
  return (
    value !== undefined &&
    value !== null &&
    value !== '' &&
    value !== 'unknown' &&
    value !== '__RELEASE__'
  );
}

export function parseRelease(html: string): string | null {
  return RELEASE_LINE.exec(html)?.[1] ?? null;
}

// server/app.mts serves the shell with Cache-Control: no-store;
// `cache: 'no-store'` skips the browser cache on the request side too.
export async function fetchDeployedRelease(): Promise<string | null> {
  const res = await fetch('/', { cache: 'no-store' });
  if (!res.ok) return null;
  return parseRelease(await res.text());
}

export function reloadPage(): void {
  window.location.reload();
}
